import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('../views/Solutions.vue')
  },
  {
    path: '/solutions/low-altitude',
    name: 'LowAltitude',
    component: () => import('../views/solutions/LowAltitude.vue')
  },
  {
    path: '/solutions/embodied-ai',
    name: 'EmbodiedAI',
    component: () => import('../views/solutions/EmbodiedAI.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: () => import('../views/Projects.vue')
  },
  {
    path: '/careers',
    name: 'Careers',
    component: () => import('../views/Careers.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  // 404 页面
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   // 如果路由有 hash，滚动到对应元素
  //   if (to.hash) {
  //     return {
  //       el: to.hash,
  //       behavior: 'smooth',
  //     };
  //   }
  //   // 如果是从其他页面返回，保持滚动位置
  //   if (savedPosition) {
  //     return savedPosition;
  //   }
  //   // 否则滚动到顶部
  //   return { top: 0 };
  // },
});

export default router;
